'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _astralLetterAndMarks = require('./astralLetterAndMarks');

var _astralLetterAndMarks2 = _interopRequireDefault(_astralLetterAndMarks);

var _bmpLetterAndMarks = require('./bmpLetterAndMarks');

var _bmpLetterAndMarks2 = _interopRequireDefault(_bmpLetterAndMarks);

var _nonBmpCodePairs = require('./nonBmpCodePairs');

var _nonBmpCodePairs2 = _interopRequireDefault(_nonBmpCodePairs);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A hashtag must contain at least one unicode letter or mark, as well as numbers, underscores, and select special characters.
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var hashtagAlpha = (0, _regexSupplant2.default)(/(?:[#{bmpLetterAndMarks}]|(?=#{nonBmpCodePairs})(?:#{astralLetterAndMarks}))/, {
  bmpLetterAndMarks: _bmpLetterAndMarks2.default,
  nonBmpCodePairs: _nonBmpCodePairs2.default,
  astralLetterAndMarks: _astralLetterAndMarks2.default
});

exports.default = hashtagAlpha;
module.exports = exports['default'];